<template>
    <v-sheet>
        <h5 class="page-text--lg mb-8 mb-lg-16 line-height-15">면접 일정표</h5>
        <expo-matching-table
            mode="view"
            v-bind="{
                program,
                matchings,
                isUserEmployee,
                isUserEmployer,
            }"
        />
    </v-sheet>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { initExpoMatching } from "@/assets/variables";

import ExpoMatchingTable from "@/components/client/expo/matching/expo-matching-table.vue";

export default {
    components: {
        ExpoMatchingTable,
    },
    props: {
        isTabActive: { type: Boolean, default: false },
    },
    data: () => ({
        loading: false,
    }),
    computed: {
        ...mapState("expo", ["program", "matchings"]),
        ...mapGetters("expo", ["_program", "isUserHost", "isUserEmployee", "isUserEmployer"]),
        ...mapGetters(["doesUserHaveConsoleScope"]),

        items() {
            return this.matchings.map(initExpoMatching);
        },
    },
    methods: {
        ...mapMutations("expo", ["pushMatchings"]),
        ...mapActions("expo", ["getMatchings"]),
        ...mapActions("expo", { expoInit: "init" }),

        init() {
            this.search();
        },

        async search() {
            if (!this.isTabActive) return;

            this.loading = true;
            try {
                await this.getMatchings();
            } finally {
                this.loading = false;
            }
        },

        updateItem(matching) {
            this.pushMatchings(matching);

            this.search();
            this.expoInit();
        },
    },
    watch: {
        isTabActive() {
            this.search();
        },
    },
    mounted() {
        this.init();
    },
};
</script>


<style lang="scss" scoped>
::v-deep .word-break-break-all {
    word-break: break-all;
}
::v-deep .white-space-pre-line {
    white-space: pre-line;
}
</style>